import { Inject, Injectable, signal } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackbarConfig } from '../config/snackbar.config';
import { SnackBarComponent } from '../../shared/snackbar/snackbar.component';
import { COMMON_APP_CONFIG } from '../tokens/common-config.token';

export type TipoNotifica = 'success' | 'warn' | 'error' | 'info';

interface Notification {
  content: {
    header?: string;
    body: string;
    type: string;
  };
}

/**
 * Notifiche in basso a destra.
 *
 * L'apertura sta dentro `showNotification`, non dentro un `effect`: un effect
 * scatta anche al primo giro, e all'avvio apriva una snackbar vuota che gli
 * stili dovevano poi nascondere.
 */
@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private snackBarRef: MatSnackBarRef<unknown> | null = null;

  readonly snackBarMessage = signal<Notification>({
    content: { header: '', body: '', type: '' },
  });

  constructor(
    private snackBar: MatSnackBar,
    @Inject(COMMON_APP_CONFIG)
    private mainConfig: Required<{ snackbar: SnackbarConfig }>
  ) {}

  showNotification(header: string | undefined, body: string, type: string): void {
    this.snackBarMessage.set({ content: { header, body, type } });

    this.hideNotification();
    this.snackBarRef = this.snackBar.openFromComponent(SnackBarComponent, {
      duration: this.mainConfig.snackbar.duration,
      verticalPosition: this.mainConfig.snackbar.verticalPosition,
      horizontalPosition: this.mainConfig.snackbar.horizontalPosition,
      panelClass: [`snackbar-${type}`],
    });
  }

  hideNotification(): void {
    this.snackBarRef?.dismiss();
    this.snackBarRef = null;
  }
}
